import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { IStore } from 'redux/IStore';
import { getArticleSearchResultsAll } from 'redux/modules/search/articlesearchresults';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IArticleTagDomainValue } from 'models/magazine/article/articletagdomainvalue';
import { getNextPageCount } from 'helpers/common';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import { getArticleCard } from 'redux/modules/magazine/article/articlecard';
import { ItemCardList } from 'components/ItemList/ItemCardList';

interface IOwnProps {
	activeTag: IArticleTagDomainValue;
	t?: (key: string) => string;
}

interface IProps extends IOwnProps, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewPageTagsComponent extends React.Component<IProps, any> {
	private sortOrder: string = 'AddedDate DESC';
	private queryType: string = 'search/tag/:keyword';

	constructor(props) {
		super(props);

		this.loadMoreData = this.loadMoreData.bind(this);
	}

	public componentDidMount() {
		const { userLanguage, activeTag } = this.props;
		this.props.getArticleSearchResultsAll(
			true,
			activeTag.value,
			this.queryType,
			this.sortOrder,
			userLanguage.languageKey,
		);
	}

	public componentDidUpdate(prevProps) {
		const { userLanguage, activeTag } = this.props;
		if (this.props.activeTag !== prevProps.activeTag) {
			this.props.getArticleSearchResultsAll(
				true,
				activeTag.value,
				this.queryType,
				this.sortOrder,
				userLanguage.languageKey,
			);
		}
	}

	public loadMoreData() {
		const { userLanguage, activeTag } = this.props;
		this.props.getArticleSearchResultsAll(
			false,
			activeTag.value,
			this.queryType,
			this.sortOrder,
			userLanguage.languageKey,
		);
	}

	public render() {
		const { t } = this.props;
		const { items, itemsPage } = this.props.articleSearchResults;

		if (!itemsPage) {
			return '';
		}

		const nextPageItems = getNextPageCount(itemsPage, items.length);

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: items.length,
			next: this.loadMoreData,
			hasMore: nextPageItems > 0,
			loader: <h4>{t('BSPortal_Common_Loading')} </h4>,
		};

		const listProps: IItemCardList = {
			items,
			itemType: c.NODE_TYPE_MAGAZINE_ARTICLE_ITEM_CARD,
			isInfiniteScroll: true,
			infiniteScrollProps,
			currentUserId: this.props.userPreferences.id,
			currentUserIsAdministrator: this.props.userPreferences.isAdministrator,
			currentUserIsEditor: this.props.userPreferences.isEditor,
			goToCard: (id: string) => this.props.getArticleCard(id),
			nextPageItems,
		};

		return (
			<div className="container viewPageTags-container">
				<div className="row">
					<div className="col">
						<div className="viewPageTags-titleInfo">
							<h1 className="viewPageTags-titleInfo-title">{this.props.activeTag?.value}</h1>
							<p className="viewPageTags-titleInfo-articleCount">
								{this.props.articleSearchResults.itemsPage.totalItems} {t('SearchArticles_Title').toLowerCase()}
							</p>
						</div>
					</div>
				</div>
				<div className="row viewPageTags-articleCards-wrapper">
					<ItemCardList {...listProps} />
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state: IStore) => {
	return {
		articleSearchResults: state?.articleSearchResults,
		userPreferences: state?.userPreferences,
		userLanguage: state?.userLanguage,
	};
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const mapDispatchToProps = (dispatch: Dispatch<IStore>, _props: IOwnProps) => ({
	dispatch,
	getArticleSearchResultsAll: (
		isFirstLoad: boolean,
		keyword: string,
		queryType: string,
		sortOrder: string,
		languageKey: number,
	) => dispatch(getArticleSearchResultsAll(isFirstLoad, keyword, queryType, sortOrder, languageKey)),
	getArticleCard: (id: string) => dispatch(getArticleCard(id)),
});

const ViewPageTags = connect(mapStateToProps, mapDispatchToProps)(ViewPageTagsComponent);

export { ViewPageTags };
